import { FC, useEffect, useMemo, useState } from 'react';
import { v4 } from 'uuid';
import cs from 'classnames';
import dayjs from 'dayjs';
import { useMethods } from '@lhb/hook';
import { isNotEmpty } from '@lhb/func';
import styles from './index.module.less';
import { antPrefix } from '@/common/components/config-v2';
import { Button, Form } from 'antd';
import IconFont from '@/common/components/IconFont';
import V2Form from '@/common/components/Form/V2Form';
import V2FormRangePicker from '@/common/components/Form/V2FormRangePicker/V2FormRangePicker';

/**
 * 日期选择器
 * @description
 * @demo
 */
const Component:FC<{
  /** 日期范围，如 ['2023-01', '2023-01'] */
  dateRange: string[],
  onChange: any,
}> = ({ dateRange, onChange }) => {

  /* state */
  const [form] = Form.useForm();
  const [customClass, setCustomClass] = useState<string>('');
  const [monthFilterOpen, setMonthFilterOpen] = useState<boolean>(false);
  // const [searchFilterHover, setSearchFilterHover] = useState<boolean>(false);

  const outerText = useMemo(() => {
    if (typeof dateRange === 'string') {
      return dateRange;
    } else if (Array.isArray(dateRange) && dateRange.length === 2) {
      if (dateRange[0] === dateRange[1]) {
        return dateRange[0];
      } else {
        return `${dateRange[0]} - ${dateRange[1]}`;
      }
    } else {
      return '';
    }
  }, [dateRange]);

  /* hooks */
  useEffect(() => {
    setCustomClass(`custom-range-picker-${v4()}`);
  }, []);

  /* methods */
  const methods = useMethods({
    onOpenChange(newOpen) {
      setMonthFilterOpen(newOpen);
    },
    onChange() {
      const value = form.getFieldValue('range');
      onChange?.(value);
    },
    openPicker() {
      const popupEle = (document.querySelector(`.${customClass}`) as any);
      if (!popupEle || popupEle.classList.contains(`${antPrefix}-picker-dropdown-hidden`)) { // 弹层显示中
        (document.querySelector(`.${customClass}-form .${antPrefix}-picker`) as any).click();
      }
    },
  });

  return <div className={styles.dateSelect}>
    <Button
      className={styles.dateSelectButton}
      onClick={methods.openPicker}
      // onMouseOver={() => setSearchFilterHover(true)}
      // onMouseLeave={() => setSearchFilterHover(false)}
    >
      <span className={styles.outerText}>{outerText || '请选择'}</span>
      <IconFont
        iconHref='pc-common-icon-a-iconarrow_down'
        className={styles.icon}
        style={{
          transform: monthFilterOpen ? 'rotate(180deg)' : 'rotate(0deg)'
        }}
      />
    </Button>
    <V2Form form={form} className={cs([styles.dateSelectFormPicker, `${customClass}-form`])}>
      <V2FormRangePicker
        name='range'
        config={{
          picker: 'month',
          onOpenChange: methods.onOpenChange,
          onChange: methods.onChange,
          popupClassName: cs(['v2-form-range-picker-for-custom-set', customClass])
        }}
        formItemConfig={{
          getValueFromEvent: (...[, dateString]) => Array.isArray(dateString) && dateString.filter(item => isNotEmpty(item)).length ? dateString : [],
          getValueProps: (value) => ({ value: Array.isArray(value) && value.filter(item => isNotEmpty(item)).length ? [dayjs(value[0], 'YYYY-MM'), dayjs(value[1], 'YYYY-MM')] : undefined })
        }}
      />
    </V2Form>
  </div>;
};

export default Component;
